import { render } from "./CartDrawerDiscountBanner.vue?vue&type=template&id=4fe3f221"
import script from "./CartDrawerDiscountBanner.vue?vue&type=script&lang=js"
export * from "./CartDrawerDiscountBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__